// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--d0fc7";
export var outline = "styles-module--outline--2a6a5";
export var small = "styles-module--small--313fe";